import { LIGHTBOX_CLOSE, LIGHTBOX_OPEN } from '../actions/lightbox'

export const lightbox = (state = { isLightboxOpen: false, photoSrc: '' }, action) => {
  switch (action.type) {
    case LIGHTBOX_OPEN:
      return {
        ...state,
        isLightboxOpen: true,
        photoSrc: action.photoSrc,
      }
    case LIGHTBOX_CLOSE:
      return { ...state, isLightboxOpen: false }
    default:
      return state
  }
}
